import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { Chatbot } from './Chatbot';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Menu',
    path: '/menu'
  }, {
    name: 'Catering',
    path: '/catering'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <div className="min-h-screen flex flex-col bg-dark text-white" data-id="element-75">
      {/* Top Bar */}
      <div className="bg-primary text-white py-1 px-4 text-xs md:text-sm font-bold text-center tracking-wider" data-id="element-76">
        HOME OF THE BBQ TRAIN • APPROVED BY BEANS THE BBQ DOG
      </div>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-dark/95 backdrop-blur-md border-b border-gray-800" data-id="element-77">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
          <div className="flex justify-between items-center h-20" data-id="element-79">
            {/* Logo */}
            <Link to="/" className="flex flex-col items-start group" data-id="element-80">
              <span className="font-retro text-2xl md:text-3xl text-white group-hover:text-primary transition-colors" data-id="element-81">
                SHORT STOP
              </span>
              <span className="text-xs text-primary font-bold tracking-[0.2em] -mt-1" data-id="element-82">
                FOOD MART
              </span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex space-x-8" data-id="element-83">
              {navItems.map(item => <Link key={item.name} to={item.path} className={`text-sm font-bold uppercase tracking-wider hover:text-primary transition-colors ${location.pathname === item.path ? 'text-primary' : 'text-gray-300'}`} data-id="element-84">
                  {item.name}
                </Link>)}
            </nav>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-85">
              {isMenuOpen ? <X size={24} data-id="element-86" /> : <Menu size={24} data-id="element-87" />}
            </button>
          </div>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && <div className="md:hidden bg-dark-card border-b border-gray-800" data-id="element-88">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-89">
              {navItems.map(item => <Link key={item.name} to={item.path} className={`block px-3 py-2 rounded-md text-base font-bold uppercase ${location.pathname === item.path ? 'bg-primary/20 text-primary' : 'text-gray-300 hover:bg-gray-800 hover:text-white'}`} onClick={() => setIsMenuOpen(false)} data-id="element-90">
                  {item.name}
                </Link>)}
            </div>
          </div>}
      </header>

      {/* Main Content */}
      <main className="flex-grow" data-id="element-91">{children}</main>

      {/* Footer */}
      <footer className="bg-dark-lighter border-t border-gray-800 pt-12 pb-8" data-id="element-92">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-94">
            {/* Contact Info */}
            <div data-id="element-95">
              <h3 className="text-xl font-retro text-white mb-4" data-id="element-96">Contact Us</h3>
              <div className="space-y-3 text-gray-400" data-id="element-97">
                <div className="flex items-start" data-id="element-98">
                  <MapPin className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" data-id="element-99" />
                  <p data-id="element-100">
                    Corner of Smith Road & East 10th Street
                    <br data-id="element-101" />
                    Bloomington, IN
                  </p>
                </div>
                <div className="flex items-center" data-id="element-102">
                  <Phone className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-103" />
                  <p data-id="element-104">812-334-0266</p>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div data-id="element-105">
              <h3 className="text-xl font-retro text-white mb-4" data-id="element-106">Hours</h3>
              <div className="space-y-3 text-gray-400" data-id="element-107">
                <div className="flex items-start" data-id="element-108">
                  <Clock className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" data-id="element-109" />
                  <div data-id="element-110">
                    <p data-id="element-111">Mon-Sat: 6am - 10pm</p>
                    <p data-id="element-112">Sun: 7am - 9pm</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social / Links */}
            <div data-id="element-113">
              <h3 className="text-xl font-retro text-white mb-4" data-id="element-114">Connect</h3>
              <div className="flex space-x-4 mb-6" data-id="element-115">
                <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-primary hover:text-white transition-colors" data-id="element-116">
                  <Facebook size={20} data-id="element-117" />
                </a>
                <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-primary hover:text-white transition-colors" data-id="element-118">
                  <Instagram size={20} data-id="element-119" />
                </a>
              </div>
              <p className="text-gray-500 text-sm" data-id="element-120">
                &copy; {new Date().getFullYear()} Short Stop Food Mart.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Chatbot */}
      <Chatbot data-id="element-121" />
    </div>;
}